export default "__VITE_ASSET__CodvdcZJ__"